import firebase from 'firebase';
import credential from 'config/firebase.credential.json';

const app = firebase.initializeApp(credential);

export const auth = firebase.auth(app);